<template>
  <div>

    <div class="row">
        <div class="col-sm-12">
          <div class="page-title-box">
            <div class="float-right">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                <li class="breadcrumb-item active">Master Data</li>
              </ol>
            </div>
            <h4 class="page-title">Master Data</h4>
          </div>
        </div>
      </div>

      <div class="card card-loader d-flex" v-if="loading">
          <div class="justify-content-center">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2">Loading</p>
          </div>
      </div>
       
      <div class="card" v-else>
          <div class="card-body">
            <div class="wrapper-table-default">
                <router-link :to="{ name: 'instanceMasterDataCreate' }" class="btn btn-success waves-effect waves-light left-action">Tambah Master Data</router-link>
                <div class="table-responsive">
                    <table id="table-default" class="table table-hover with-action-last" cellspacing="0" width="100%">
                        <thead>
                            <tr>
                                <th>Nama Master Data</th>
                                <th>Tipe Master Data</th>
                                <th>Aksi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item) in dataMasterData" :key="item.id">
                                <td>{{item.name}}</td>
                                <td>{{item.type}}</td>
                                <td>
                                    <router-link class="btn btn-primary waves-effect waves-light"
                                        :to="{ name: 'instanceMasterDataEdit', params: { id: item.id } }"
                                        >
                                        <i class="fas fa-pen"></i>
                                    </router-link>
                                    <button class="btn btn-danger waves-effect waves-light ml-2" @click.prevent="deleteItem(item.id)">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
    data() {
        return {
            loading: true,
            dataMasterData: [],
        }
    },
    methods: {
        loadData() {
            this.loading = true;
            this.$http.get(`${this.API_URL}master-data`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })
            .then(response => {
                this.loading = false;
                const result = response.data;
                if(result.success) {
                    this.dataMasterData = result.data
                    setTimeout(() => {
                        this.dataTableSearch()
                    }, 500);
                }else {
                    this.sAlert('error', result.message)
                }
            })
            .catch(error => {
                this.loading = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
        deleteItem(id){
            Swal.fire({
            title: 'Apakah anda yakin untuk menghapus ?<br> <b>Data ini memiliki relasi dengan data lainnya, pastikan dengan baik!<b>',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, Hapus!'
            }).then((result) => {
                if (result.value) {
                     this.loading = true
                     this.$http.delete(`${this.API_URL}master-data/delete/${id}`, {
                        headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                    })
                    .then(() => {
                        this.loadData()
                    })
                    .catch(error => {
                        this.loading = false;
                        this.errorHandler(error)
                    });
                }
            })
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>